import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { useMemo } from 'react'
import { DYNAMIC_PAGES_MAP } from 'page-constants'
import { Cohort } from 'root-constants'
import { getPageIdFromPathName } from 'helpers/getPageIdFromPathName'

export const useGetPageInfo = () => {
  const { pathname } = useLocation()
  const cohort = useSelector(selectCurrentVariantCohort)

  const currentVariantPageList = useMemo(
    () =>
      DYNAMIC_PAGES_MAP[cohort as Cohort] ||
      DYNAMIC_PAGES_MAP[Cohort.VARIANT_ONE],
    [cohort],
  )

  const hasBurgerMenu = useMemo(() => {
    const currentPageId = getPageIdFromPathName(pathname)
    return !!currentVariantPageList.find(({ id }) => id === currentPageId)
      ?.hasBurgerMenu
  }, [pathname, currentVariantPageList])

  const hasQuestionDescription = useMemo(() => {
    const currentPageId = getPageIdFromPathName(pathname)
    return !!currentVariantPageList.find(({ id }) => id === currentPageId)
      ?.hasQuestionDescription
  }, [pathname, currentVariantPageList])

  return {
    currentVariantPageList,
    hasBurgerMenu,
    hasQuestionDescription,
  }
}
